<ng-container *ngIf="quickBetState$ | async as quickBetState">
    <ms-stake
        #stakeComponent
        [stake]="quickBetState.stakeState.stake"
        [keypadId]="QUICK_BET_NUMPAD"
        [errors]="hasBetslipErrors$"
        [numpadSource]="numpadSource"
        [disabled]="disabled"
        [adornmentStart]="adornmentStart"
        [showIncrementalStakes]="showIncrementalStakes"
        [emptyCharacter]="stakeFieldPlaceHolder"
        [focusPlaceholder]="focusPlaceholder"
        (stakeChanged)="onStakeChange($event)"
        (numpadOpen)="onStakeClick()">
    </ms-stake>
</ng-container>
